<template>
  <!-- 视频相关解答 -->
  <div class="cialdetrelans">
    <div class="sptit between">
      <sub-title text="相关视频解答?" />
      <div class="ckgd" @click="tojumpmove">查看更多></div>
    </div>
    <div class="tjvidlist between wrap">
      <div
        class="tjviditem flex_start"
        v-for="(item, index) in list"
        :key="index"
        @click="tojump(item)"
      >
        <div class="cov">
          <img :src="item.preview_pic" alt="" />
        </div>
        <div class="ritext">
          <div class="newtit ellipsis">{{ item.title }}</div>
          <div class="rt2">{{ item.true_name }}</div>
          <div class="itmbom between">
            <div>{{ item.updated_at | timecutout }}</div>
            <div>{{ item.view_num }}次阅读</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    subTitle,
  },
  methods: {
    tojump(item) {
      this.$router.push({
        path: "/laws/videoimdet",
        query: {
          videoinId: item.id,
        },
      });
    },
    tojumpmove() {
      this.$router.push({
        path: "/laws/videoclaim",
      });
    },
  },
  filters: {
    timecutout(val) {
      return val.substring(0, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.cialdetrelans {
  width: 100%;
  .sptit {
    padding: 22px 20px 22px 0;
    border-bottom: 1px solid #eee;
    .ckgd {
      font-size: 14px;
      color: #999999;
      cursor: pointer;
      &:hover {
        color: #0465ea;
      }
    }
  }
  .tjvidlist {
    padding: 15px 35px 40px;
    .tjviditem {
      width: 360px;
      margin-top: 25px;
      cursor: pointer;
      &:hover {
        .ritext .newtit {
          color: #0465ea;
        }
      }
      .cov {
        margin-right: 16px;
        img {
          width: 140px;
          height: 78px;
        }
      }
      .ritext {
        font-size: 14px;
        color: #999999;
        .newtit {
          font-size: 16px;
          color: #333333;
          width: 200px;
        }
        .rt2 {
          margin: 8px 0;
        }
      }
    }
  }
}
</style>